module.exports = __webpack_public_path__ + "img/icon_page2_phone_2.711032b3.png";